export const detailUrl = ({ id }) => {
  return `/configcenter/groups-and-users/user/${id}`;
};

export const overviewUrl = () => {
  return `/configcenter/groups-and-users`;
};

export const constructStrRep = (obj) => {
  return (
    obj?.str_representation ||
    obj?.corporate_name ||
    obj?.last_name ||
    obj?.first_name ||
    obj?.legal_id ||
    obj?.email ||
    "Användare"
  );
};
